import { render, staticRenderFns } from "./Kan.vue?vue&type=template&id=a50ae7b2&scoped=true&"
import script from "./Kan.vue?vue&type=script&lang=js&"
export * from "./Kan.vue?vue&type=script&lang=js&"
import style0 from "./Kan.vue?vue&type=style&index=0&id=a50ae7b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50ae7b2",
  null
  
)

export default component.exports